<template>
  <Form ref="form" :model="form" :rules="ruleValidate" label-position="left" :label-width="80">
    <FormItem label="姓名" prop="name">
      <Input v-model="form.name" placeholder="请输入姓名"></Input>
    </FormItem>
    <FormItem label="手机号" prop="tel">
      <Input v-model="form.tel" placeholder="请输入手机号"></Input>
    </FormItem>
    <FormItem label="工作单位">
      <Input v-model="form.work" placeholder="请输入工作单位"></Input>
    </FormItem>
    <FormItem label="职称">
      <Input v-model="form.professional" placeholder="请输入职称"></Input>
    </FormItem>
    <FormItem label="所属院系">
      <Input v-model="form.academy" placeholder="请输入所属院系"></Input>
    </FormItem>
    <FormItem label="状态">
      <RadioGroup v-model="form.status">
        <Radio :label="1"><span>正常</span></Radio>
        <Radio :label="2"><span>禁用</span></Radio>
      </RadioGroup>
    </FormItem>
    <FormItem>
      <Button type="primary" :loading="loading" @click="handleSubmit('form')">保存数据</Button>
    </FormItem>
  </Form>
</template>

<script>
export default {

  props: {
    condition: {
      type: [Boolean, Number, String, Array],
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        //全部
        library_id: localStorage.getItem('libId'),
        user_type: 3,
        status: 1,//状态 1正常 2禁用
        //管理员
        username: '',//用户名
        password: null,//密码
        // 编辑、专家
        name: '',//姓名
        tel: '',//手机号
        //专家
        work: '',//工作单位
        professional:'',//职称
        academy:'',//所属院系
      },
      ruleValidate: {
        name: [
          {required: true,message: '请输入姓名', trigger: 'blur'},
        ],
        tel: [
          {required: true, message: '请输入手机号', trigger: 'blur' },
          { type: 'string', min: 11, message: '小于11位', trigger: 'blur'},
          { type: 'string', max: 11, message: '大于11位', trigger: 'blur'},
          { pattern:'^1(3[0-9]|4[0-9]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[0-9])[0-9]{8}$',message: '请输入正确的手机号',trigger: 'blur'}
        ],
      },
    }
  },
  methods: {

    /*****************************************************************
     * 表单验证
     * @param   {name}             要验证的表单名称
     *****************************************************************/
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.loading = true
          !this.condition ? this.addSubmit() : this.editSubmit()
        } else {
          this.loading = false
          this.$Message.error('请核对输入内容!');
        }
      })
    },

    /*****************************************************************
     * 添加数据
     *****************************************************************/
    addSubmit() {
      this.$httpsencrypt.post('api/contributeweb/v3/users/add', this.form).then(val => {
        this.$emit('operationState', true)
        this.loading = false
        this.$Message.success('添加成功!');
      }).catch(err => {
        this.loading = false
      })
    },

    /*****************************************************************
     *
     * 修改数据
     *
     *****************************************************************/
    editSubmit() {
      this.$set(this.form,'id',this.condition)
      this.$httpsencrypt.post('api/contributeweb/v3/users/edit', this.form).then(val => {
        this.$emit('operationState', true)
        this.loading = false;
        this.$Message.success('修改成功!');
      }).catch(err => {
        this.loading = false;
      })
    },

    /*****************************************************************
     *
     * 单条查询数据
     *
     *****************************************************************/
    selData() {
      this.loading = true
      let cond = {
        id:this.condition,
        library_id:localStorage.getItem('libId'),
        user_type:3,
      }
      this.$httpsencrypt.post('api/contributeweb/v3/users/info',cond).then(val => {
        this.form.name = val.data.name
        this.form.tel = val.data.tel
        this.form.status = val.data.status
        this.form.work = val.data.work
        this.form.professional = val.data.professional
        this.form.academy = val.data.academy
        this.loading = false
      }).catch(err => {
        this.loading = false
      })
    },


  },
  mounted() {
    if (this.condition) this.selData()
  }
};
</script>
